export default __webpack_public_path__ + "static/media/push.0f6d547a.mp3";